import { paginationStyles } from "@insite/content-library/Widgets/InvoiceHistory/InvoiceHistoryPagination";
import { getMgbwPaginationOverrides } from "@tSurya/Common/Utilities/mgbwPaginationOverrides";

paginationStyles.pagination = getMgbwPaginationOverrides();
